import { useTranslation } from 'react-i18next';
import { useDataContext } from '../../contexts/DataContext';
import Patient from '../../models/Patient';
import PatientTableRow from './TableRow';

type Props = {
    patients: Patient[];
};

const PatientTable = ({ patients }: Props) => {
    const { t } = useTranslation();
    const { currentUserRole } = useDataContext();

    return (
        <table className={`entity ${currentUserRole === 'admin' ? 'admin-view' : ''}`}>
            <thead>
                <tr>
                    {currentUserRole === 'admin' && (
                        <>
                            <th>{t('label.username')}</th>
                            <th>{t('label.user_code')}</th>
                        </>
                    )}
                    <th className="admin">{t('label.code')}</th>
                    {/* <th className='th-8pc'>{t('label.sex')}</th> */}
                    <th className="th-5pc">{t('label.age')}</th>
                    <th className="th-5pc">CDR</th>
                    <th className="th-5pc">SOB</th>
                    {/* <th className='th-5pc'>MMSE</th> */}
                    <th className="apoe">ApoE</th>
                    {/* <th className="th-10pc">A&beta; PET</th> */}
                    <th className="th-5pc">{t('label.header_ctrl')}</th>
                    <th>{t('label.header_mci')}</th>
                    <th>{t('label.header_ad')}</th>
                    <th>{t('label.conclusion')}</th>
                </tr>
            </thead>
            <tbody>
                {patients.map((patient) => (
                    <PatientTableRow
                        key={patient.id}
                        patient={patient}
                    />
                ))}
            </tbody>
        </table>
    );
};

export default PatientTable;
